<script>
export default {
  props: {
    filename: {
      type: String,
      required: true,
    },
  },

  computed: {
    apiURL() {
      return process.env.NODE_ENV === 'development'
        ? 'http://localhost:8000'
        : 'https://api.sistema.niekienovaikai.lt'
    },
  },
}
</script>

<template>
  <a :href="`${apiURL}${filename}`" target="_blank">
    <slot />
  </a>
</template>
